import { ccwpApi } from "@/services";
import { CREDITOR_ATTRIBUTE_HISTORY } from "@/services/constant/apiPath";
// Define a service using a base URL and expected endpoints
type CreditorSummaryRequestType = {
  caseId: string;
  creditorId: string;
};
export const CreditorSummaryApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreditorSummaryData: builder.query<any, CreditorSummaryRequestType>({
      query: (postData) =>
        `Creditor/GetCreditorSummaryViewDetails?CaseId=${postData?.caseId}&CreditorId=${postData?.creditorId}`,
      transformResponse: (response: { results: any[] }) => response.results,
      providesTags: ["CreditorSummary"],
    }),
    getCreditorSummaryHeaderData: builder.query<
      any,
      CreditorSummaryRequestType
    >({
      query: (postData) =>
        `Creditor/GetCreditorSummaryHeaderDetails?CaseId=${postData?.caseId}&CreditorId=${postData?.creditorId}`,
      transformResponse: (response: { results: any[] }) => response.results,
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCreditorSummaryDataQuery,
  useGetCreditorSummaryHeaderDataQuery,
} = CreditorSummaryApi;

export const CreditorAttributeHistory = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreditorAttributeHistoryData: builder.query<any, any>({
      query: ({ creditorId, ...args }) => ({
        url: CREDITOR_ATTRIBUTE_HISTORY + creditorId,
        params: { ...args },
      }),
      transformResponse: (response: any) => response,
    }),
  }),
});
export const {
  useGetCreditorAttributeHistoryDataQuery,
  useLazyGetCreditorAttributeHistoryDataQuery,
} = CreditorAttributeHistory;
export const CreditorDistributions = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentListApi: builder.query<any, any>({
      query: (args) => ({
        url: "/Payment/GetPaymentListByCreditor",
        params: { ...args },
      }),
      transformResponse: (response: any) => response,
    }),
    getCreditorSettelmentListApi: builder.query<any, any>({
      query: (args) => ({
        url: "/Payment/GetSettlementListByCreditor",
        params: { ...args },
      }),
      transformResponse: (response: any) => response,
    }),
  }),
});
export const { useGetPaymentListApiQuery,useLazyGetPaymentListApiQuery,useGetCreditorSettelmentListApiQuery } = CreditorDistributions;
